import React, { useState, useEffect } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';

import { Flex, Spinner } from './components';

import { Dashboard, Home, Admin, Release, Waitlist } from './pages';

import { TOS, Privacy } from './pages/Home/sections';

import Background from './assets/Background.svg';

import 'react-notifications/lib/notifications.css';

const PageContainer = styled(Flex)`
  width: 100%;
  min-height: 100vh;
  padding: 0 20px;
  background: #101225;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-size: cover;
`;

const App = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    verifySession();
  }, []);

  const verifySession = () => {
    axios
      .get('/api/auth/verify')
      .then(res => {

        setIsAuthenticated(res.data.login);

        if (res.data.userData) {
          setUserData(res.data.userData);
          setIsAdmin(res.data.isAdmin);
        }

        setIsLoading(false);

      })
      .catch(err => {
        console.error(err);
      });
  }

  const login = () => {
    setIsLoading(true);

    axios.get('/api/auth/login').then(res => {

      if (res.data.redirect) {
        window.location = res.data.redirect;
      }

    })
      .catch(err => {
        console.error(err);
      });

  }

  if (isLoading) return (
    <Spinner></Spinner>
  )

  return (
    <PageContainer dir="column">
      <BrowserRouter>
        <Switch>
          <Route exact path="/" render={() =>
            <Home />}
          />
          <Route exact path="/terms" render={() =>
            <TOS />}
          />
          <Route exact path="/privacy" render={() =>
            <Privacy />}
          />
          <Route path="/dashboard" render={() =>
            <Dashboard userData={userData} login={login} isAdmin={isAdmin} />}
          />
          <Route path="/admin" render={() =>
            <Admin userData={userData} login={login} isAdmin={isAdmin} />}
          />
          <Route path="/release" render={() =>
            <Release login={login} />}
          />
          <Route path="/waitlist/unsub-waitlist" render={(props) =>
            <Waitlist {...props} />}
          />
          <Route path="/">
            <Redirect to="/" />
          </Route>
        </Switch>
      </BrowserRouter>
    </PageContainer>
  )

};

export default App;
